import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';

import { SharedService } from '../../../../shared/shared.service';
import {
  ListSessioniOlaDTO,
  SelectDTO,
  SessioneOlaDTO,
} from './../../../../model/newModel';
import { ASessioneOlaService } from './../a-sessione-ola.service';

@Component({
  selector: 'app-list-sessioni-ola',
  templateUrl: './list-sessioni-ola.component.html',
  styleUrls: ['./list-sessioni-ola.component.css'],
})
export class ListSessioniOlaComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  listSessioniOla: ListSessioniOlaDTO;
  idAnnoSessioneOla: number;
  anniSessioneOla: SelectDTO[];
  tempListSessioniOla: SessioneOlaDTO[];
  showSessioniOla: boolean;

  ngOnInit(): void {
    super.ngOnInit();
    this.spinner.show();
    this.aSessioneOlaService.search().subscribe(
      (result) => {
        this.listSessioniOla = result;
        if (this.listSessioniOla.sessioniOla.length > 0) {
          this.showSessioniOla = true;
        } else {
          this.showSessioniOla = false;
        }
        this.tempListSessioniOla = Object.assign(
          [],
          this.listSessioniOla.sessioniOla
        );
        this.anniSessioneOla = [];
        const annoDefault = new SelectDTO();
        annoDefault.value = '-1';
        annoDefault.viewValue = 'TUTTI GLI ANNI';
        this.anniSessioneOla.push(annoDefault);
        this.tempListSessioniOla.forEach((sessioneOla: SessioneOlaDTO) => {
          const annoCorrente = new SelectDTO();
          annoCorrente.value = '' + sessioneOla.anno;
          annoCorrente.viewValue = '' + sessioneOla.anno;
          this.anniSessioneOla.push(annoCorrente);
        });
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  filtroFE(idAnnoSessioneOla: string) {
    if (!!idAnnoSessioneOla && Number(idAnnoSessioneOla) !== -1) {
      this.listSessioniOla.sessioniOla = this.tempListSessioniOla.filter(
        (sessioneOla: SessioneOlaDTO) =>
          sessioneOla.anno === Number(idAnnoSessioneOla)
      );
    } else {
      this.listSessioniOla.sessioniOla = this.tempListSessioniOla;
    }
  }

  goToSessioneOlaEditDetail(idSessioneOla: number, active: boolean) {
    if (active) {
      this.router.navigate(['/a-sessione-ola/modifica'], {
        queryParams: { idSessioneOla },
      });
    } else {
      const text = 'La sessione non è attiva e non può essere modificata';
      this.sharedService.openWarningModal(text);
    }
  }

  goToSessioneOlaDelete(idSessioneOla: number) {
    this.aSessioneOlaService.eliminaSessione(idSessioneOla).subscribe(
      (result) => {
        if (result) {
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              window.location.reload();
            });
        } else {
          const text =
            'La sessione non può essere eliminata perchè precedentemente utilizzata';
          this.sharedService.openWarningModal(text);
        }
      },
      (error) => {
        console.log('Errore search');
        this.sharedService.openKoModal();
      }
    );
  }

  convertMese(numeroMese: number): string {
    return 'todo';
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    public aSessioneOlaService: ASessioneOlaService
  ) {
    super();
  }
}
